import { render } from "./SellersManagerView.vue?vue&type=template&id=2b093275"
import script from "./SellersManagerView.vue?vue&type=script&lang=js"
export * from "./SellersManagerView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__